import ApplicationLayout from 'components/ApplicationLayout';
import CustomProvider from 'components/CustomProvider';
import LoginForm from 'components/LoginForm';
import LoginSignupLayout from 'components/LoginSignupLayout';

type Props = {
  returnTo?: string;
};

export default function Login({ returnTo }: Props) {
  return (
    <CustomProvider>
      <ApplicationLayout>
        <LoginSignupLayout>
          {/* we could add react router here for the signup page */}
          <LoginForm returnTo={returnTo} />
        </LoginSignupLayout>
      </ApplicationLayout>
    </CustomProvider>
  );
}
